<template>
  <section class="custom-blog-wrapper">
    <!-- Header -->
    <div class="row">
      <!-- Search -->
      <div class="col-2">
        <z-search v-model.trim="currentSearchTerm" name="search" label="" placeholder="Search" :readonly="loading.blogs" @search="search" />
      </div>
      <div class="col-1">
        <button v-if="isAdmin" class="btn btn-primary btn-sm" @click="add">Add</button>
      </div>
      <!-- Filters -->
      <div class="col-4">
        <div class="input-group">
          <i class="fas fa-filter filterIcon"></i>
          <select v-model="currentType" class="form-control custom-types" title="blog type" :disabled="loading.blogs">
            <option v-for="item of blogTypes" :key="item.value" :value="item.value">{{ item.name }}</option>
          </select>
          <select v-if="isAdmin" v-model="currentStatus" class="form-control custom-statuses" title="blog status" :disabled="loading.blogs">
            <option v-for="item of blogStatuses" :key="item.value" :value="item.value">{{ item.name }}</option>
          </select>
          <span class="input-group-text custom-clear" @click="clearFilter"><i class="fas fa-times"></i></span>
        </div>
      </div>
      <!-- Placeholder -->
      <div class="col"></div>
      <!-- Pagination -->
      <div class="col-1">
        <z-select v-model="currentPageSize" :options="pageSizes" label="" name="pageSize" :disabled="loading.blogs" />
      </div>
      <div class="col">
        <nav>
          <z-paginate v-model="page" :page-count="pages" @change="search" />
        </nav>
      </div>
      <div class="col-2 text-right">
        <h5 class="mr-2" title="# items">{{ numItems }}</h5>
        <span class="custom-items">items</span>
      </div>
    </div>
    <!-- Blog List -->
    <div class="row mt-2 custom-blog-list">
      <blog-record v-for="item of blogs" :key="item.blog" :blog="item" :user="user" @edit="edit" @more="more" />
    </div>
    <!-- Footer -->
    <div class="row">
      <div class="col"></div>
    </div>
    <!-- Dialogs -->
    <dialog-blog v-model="actionBlog" @close="close()" @remove="remove()" @saved="saved" />
    <dialog-view v-model="actionView" @close="close()" />
    <confirm-action
      v-model="actionRemove"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      :d-style="'z-index: 1070'"
      :bd-style="'z-index: 1065'"
      @closing="close"
      @proceed="removeBlog"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { blogStore } from '@/stores/blog'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZPaginate from '@/components/utilities/elements/Paginate.vue'
import BlogRecord from '@/components/blog/blog-record.vue'
import DialogBlog from '@/components/blog/forms/dialog-blog.vue'
import DialogView from '@/components/blog/forms/dialog-view.vue'
import ConfirmAction from '@/components/utilities/elements/ConfirmDialog.vue'
export default {
  name: 'BlogListing',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate,
    DialogBlog,
    DialogView,
    BlogRecord,
    ConfirmAction
  },
  data() {
    return {
      actionBlog: null,
      actionView: null,
      actionRemove: null,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      page: 1,
      confirmTitle: 'Remove',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to delete this blog?',
      showAttachments: false,
      showComments: false
    }
  },
  async mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    ...mapState(blogStore, [
      'loading',
      'blog',
      'blogs',
      'blogCount',
      'comments',
      'searchTerm',
      'pageSize',
      'orderBy',
      'sortBy',
      'blogStatus',
      'blogFilter',
      'blogType'
    ]),
    blogStatuses() {
      let _types = []
      if (this.lookups['BlogStatus']) {
        this.lookups['BlogStatus'].forEach((element) => {
          _types.push({
            name: element.name,
            value: element.value
          })
        })
      }
      return _types
    },
    blogTypes() {
      let _types = []
      if (this.lookups['BlogType']) {
        this.lookups['BlogType'].forEach((element) => {
          _types.push({
            name: element.name,
            value: element.value
          })
        })
      }
      return _types
    },
    user() {
      let _data = null
      if (this.profile) {
        _data = this.profile.user
      }
      return _data
    },
    isAdmin() {
      let _is = false
      if ([1, 2, 3, 4, 5, 7, 9, 12].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    currentStatus: {
      get() {
        return this.blogStatus
      },
      set(value) {
        this.setStatus(value)
        this.search()
      }
    },
    currentType: {
      get() {
        return this.blogType
      },
      set(value) {
        this.setType(value)
        this.search()
      }
    },
    currentSearchTerm: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.setSearchTerm(value)
      }
    },
    currentPageSize: {
      get() {
        return this.pageSize
      },
      set(value) {
        this.page = 1
        this.setPageSize(value)
        this.search()
      }
    },
    numItems() {
      let _num = 0
      if (this.blogs) {
        _num = this.blogCount
      }
      return _num
    },
    pages() {
      let _pages = 0
      if (this.blogs) {
        _pages = Math.ceil(this.blogs.count / this.currentPageSize)
      }
      return _pages
    },
    offset() {
      return (this.page - 1) * this.currentPageSize
    },
    currentOrderBy: {
      get() {
        return this.orderBy
      },
      set(value) {
        this.setOrderBy(value)
      }
    },
    currentSortBy: {
      get() {
        return this.sortBy
      },
      set(value) {
        this.setSortDir(value)
      }
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(blogStore, [
      'resetBlogs',
      'getBlogs',
      'getComments',
      'setSearchTerm',
      'setPageSize',
      'setOrderBy',
      'setSortDir',
      'initBlog',
      'updateBlog',
      'setBlog',
      'setStatus',
      'setType',
      'deleteBlog'
    ]),
    async init() {
      this.showAttachments = false
      this.showComments = false
      await this.getLookups({
        keys: ['BlogType', 'BlogStatus'],
        firm: 1,
        refresh: false
      })
      await this.search()
    },
    close() {
      this.actionBlog = null
      this.actionView = null
      this.actionRemove = null
    },
    clearFilter() {
      this.resetBlogs()
      this.search()
    },
    async search(term) {
      if (term) {
        if (term === '') {
          this.setSearchTerm('')
          this.resetBlogs()
        }
      }
      let options = {
        firm: this.profile.firm,
        searchTerm: this.currentSearchTerm,
        offset: this.offset,
        pageSize: this.currentPageSize,
        orderBy: this.currentOrderBy,
        sortBy: this.currentSortBy,
        type: this.currentType,
        status: this.currentStatus
      }
      await this.getBlogs(options)
    },
    add() {
      this.initBlog(this.profile.firm)
      this.updateBlog({
        name: 'createdBy',
        value: this.profile.user
      })
      this.actionBlog = true
    },
    edit(blog) {
      if (this.blogs) {
        let found = this.blogs.find((x) => parseInt(x.blog) === parseInt(blog))
        if (found) {
          this.setBlog(found)
          this.actionBlog = true
        }
      }
    },
    async saved() {
      this.actionBlog = null
      await this.search()
    },
    more(blog) {
      if (this.blogs) {
        let found = this.blogs.find((x) => parseInt(x.blog) === parseInt(blog))
        if (found) {
          this.setBlog(found)
          this.actionView = true
        }
      }
    },
    remove() {
      this.actionRemove = this.blog
    },
    async removeBlog() {
      console.log('Remove Blog:', this.blog)
      await this.deleteBlog(this.blog.blog)
      this.initBlog(this.profile.firm)
      this.close()
      await this.search()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-blog-wrapper {
  width: 100%;
  text-align: left;
}
.custom-blog-list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 65vh;
  padding: 15px;
}
.custom-filter {
  display: inline;
}
.filterIcon {
  top: 8px;
  font-size: 1.2em;
  margin-right: 5px;
}
.custom-statuses {
  max-width: 180px;
}
.custom-types {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  margin-right: 5px;
}
.custom-clear {
  cursor: pointer;
}
</style>
